import Net from '../core/libs/Net';

import { TSubmitContactInfoRequest } from 'TProtocol/contactinfo/messages';
import { TAppContact } from 'TProtocol/common/models';

export const submitContactInfo = ({token, contact}: { token: string, contact: TAppContact }) => {
  const request: TSubmitContactInfoRequest = new TSubmitContactInfoRequest({
    token, submittedContact: contact
  })

  const client = Net.createContactInfoService();
  return client.submitContactInfo(request);
}
